import { Outlet, createFileRoute } from '@tanstack/react-router'
import { accountQueryOptions } from '#/api/accounts'
import { workspacesQueryOptions } from '#/api/workspaces'

export const Route = createFileRoute('/_authed/accounts/$accountId')({
  beforeLoad: async ({ context, params }) => {
    const [account] = await Promise.all([
      context.queryClient.ensureQueryData(
        accountQueryOptions(params.accountId),
      ),
      context.queryClient.ensureQueryData(
        workspacesQueryOptions(params.accountId),
      ),
    ])
    return { account }
  },
  component: AccountLayout,
})

function AccountLayout() {
  return <Outlet />
}
